/* eslint-disable*/
import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from '@material-ui/core';
import theme from 'theme';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  performancereviewAmazonOwnReviewResult,
  performancereviewRakutenOwnReviewResult,
  performancereviewOwnDataLoading,
  performancereviewAmazonOwnScore,
  performancereviewRakutenOwnScore,
  performancereviewAmazonOwnItemData,
  performanceModalOpen,
  setPerformanceModalOpen,
  resetKeyword,
  setWordType,
  setSeoType,
  fetchKeywordList
} from 'feactures/performancereview/performancereviewSlice';
import { currentchannel } from 'feactures/channel/channelSlice';
import BasicResultDialog from './BasicResultDialog';
import SeoResultDialog from './SeoResultDialog';
import DetailAnalysisDialog from './DetailAnalysisDialog';
import OKicon from 'components/atoms/icon/OKicon';
import NGicon from 'components/atoms/icon/NGicon';

function Row(props) {
  const { data, index: rowIndex } = props;
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const handleOnClick = async (detail) => {
    // 「一般ワード」または「指名ワード」を含んでいる場合
    if (
      ['一般ワード', '指名ワード'].some((word) => detail.name.includes(word))
    ) {
      dispatch(resetKeyword()); // キーワードリセット

      // setWordType の設定
      const wordType = detail.name.includes('一般ワード')
        ? 'general'
        : detail.name.includes('指名ワード')
        ? 'specific'
        : null;

      if (wordType) {
        await dispatch(setWordType(wordType)); // dispatch の完了を待つ
      }

      // setSeoType の設定
      const seoType = detail.name.includes('オーガニック')
        ? 'organic'
        : detail.name.includes('広告')
        ? 'sponsor'
        : null;

      if (seoType) {
        await dispatch(setSeoType(seoType)); // dispatch の完了を待つ
      }
      dispatch(fetchKeywordList('own'));
      dispatch(fetchKeywordList('other'));
    }
  };
  return (
    <React.Fragment>
      <TableRow
        sx={{ '& > *': { borderBottom: 0 }, cursor: 'pointer' }}
        onClick={() => setOpen(!open)}
      >
        <TableCell component="th" scope="row" sx={{ border: 0 }}>
          <Typography
            fontWeight="bold"
            color="rgba(113,140,198,1)"
            fontSize="13px"
          >
            {data.name}
          </Typography>
        </TableCell>
        <TableCell align="right" sx={{ border: 0 }} width="25px">
          <img
            alt="score"
            src={`/static/images/performanceReview/rank_${data.score}.png`}
            style={{
              display: 'inline-block',
              width: '25px'
            }}
          />
        </TableCell>
        <TableCell align="center" sx={{ border: 0, pl: 0 }} width="30px">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      {/*開閉する部分 */}
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {data.details.map((detail, index) => {
              return (
                <Box
                  sx={{ margin: 1 }}
                  p={1}
                  bgcolor="#FAFBFC"
                  borderRadius={1}
                  key={index}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Box
                      display="flex"
                      flexWrap="wrap"
                      alignItems="center"
                      columnGap={1}
                      rowGap={0.5}
                    >
                      <Typography fontWeight="bold" fontSize="13px">
                        {detail.id}
                      </Typography>

                      <Typography fontWeight="bold" fontSize="13px">
                        {detail.name}
                      </Typography>

                      <Typography
                        fontSize="11px"
                        color={theme.palette.text.secondary}
                        sx={{
                          minWidth: '200px',
                          flexShrink: 1,
                          whiteSpace: 'normal'
                        }}
                      >
                        {detail.judgmentDescription || null}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap="13px">
                      {detail.evaluationFlag == 1 ? <OKicon /> : <NGicon />}
                      <Button
                        color="groupSelected"
                        variant="contained"
                        onClick={(event) => {
                          event.stopPropagation(); // 親要素のテーブルの開閉が起きないようイベントの伝播を停止
                          dispatch(
                            setPerformanceModalOpen({
                              index: rowIndex,
                              open: true,
                              detailsIndex: index
                            })
                          );
                          handleOnClick(detail);
                        }}
                        size="small"
                        sx={{ minWidth: '50px' }}
                      >
                        詳細
                      </Button>
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function CollapsibleTable(props) {
  const { dataList } = props;
  return (
    <TableContainer component={Paper} sx={{ boxShadow: 0 }}>
      <Table aria-label="collapsible table">
        <TableBody>
          {dataList.map((data, index) => (
            <Row key={index} data={data} index={index} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const ReviewResult = () => {
  const isLoading = useSelector(performancereviewOwnDataLoading);
  const amazonDataList = useSelector(performancereviewAmazonOwnReviewResult);
  const rakutenDataList = useSelector(performancereviewRakutenOwnReviewResult);
  const amazonScore = useSelector(performancereviewAmazonOwnScore);
  const rakutenScore = useSelector(performancereviewRakutenOwnScore);
  const amazonOwnItemData = useSelector(performancereviewAmazonOwnItemData);
  const channel = useSelector(currentchannel);
  const modalOpen = useSelector(performanceModalOpen);
  let dataList = [];
  let score;
  let amazon_click_supported_flag;
  if (channel == 1) {
    dataList = amazonDataList;
    score = amazonScore;
    amazon_click_supported_flag = amazonOwnItemData?.click_supported_flag;
  } else if (channel == 2) {
    dataList = rakutenDataList;
    score = rakutenScore;
  }
  const detailTitle = `${
    dataList[modalOpen.index]?.details[modalOpen.detailsIndex]?.id
  }${dataList[modalOpen.index]?.details[modalOpen.detailsIndex]?.name}`;
  return (
    <Box
      width="49%"
      bgcolor="#FFFFFF"
      borderRadius={3}
      p={2}
      flexShrink={0}
      minHeight="200px"
    >
      <Typography
        fontWeight={'bold'}
        fontSize={'18px'}
        color="rgba(113,140,198,1)"
        pl={1}
      >
        ■診断結果
      </Typography>
      {isLoading && !modalOpen.open ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="200px"
        >
          <CircularProgress />
        </Box>
      ) : score == 'nodata' ? (
        <Box
          height="200px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Typography>
            {amazon_click_supported_flag == false
              ? '該当商品は弊社で取得できないデータのため分析できません'
              : '新規登録時はデータは翌日反映されます'}
          </Typography>
        </Box>
      ) : dataList.length == 0 ? (
        <Box
          height="200px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Typography>商品を選択してください</Typography>
        </Box>
      ) : (
        <CollapsibleTable dataList={dataList} />
      )}

      {modalOpen.open && (
        <>
          {dataList[modalOpen.index].name == '2.検索' ? (
            <SeoResultDialog detailTitle={detailTitle} />
          ) : dataList[modalOpen.index].name == '2.価格' ||
            dataList[modalOpen.index].name == '3.価格' ? (
            <DetailAnalysisDialog />
          ) : dataList[modalOpen.index].name == '3.商品ページ' ||
            dataList[modalOpen.index].name == '4.商品ページ' ? (
            <DetailAnalysisDialog />
          ) : dataList[modalOpen.index].name == '1.集客施策' ||
            dataList[modalOpen.index].name == '6.ストア' ? (
            <DetailAnalysisDialog />
          ) : (
            <DetailAnalysisDialog />
          )}
        </>
      )}
    </Box>
  );
};

export default ReviewResult;
